<template>
  <div class="dropdown">
  <button class="btn btn-primary btn-cons btn-block"
            id="export-users-button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false">
      <i class="fa fa-cloud-download"></i>
      <span class="bold">{{ $t('users.export') }}</span>
      <span class="caret"></span>
    </button>
    <ul class="dropdown-menu" aria-labelledby="export-users-button">
      <li class="dropdown-item">
        <button type="button" @click.prevent="triggerExport('csv')">
          <span class="bold">CSV</span>
        </button>
      </li>
      <li class="dropdown-item">
        <button type="button" @click.prevent="triggerExport('xls')">
          <span class="bold">XLS</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'UsersExportButton',
    props: ['label'],

    methods: {
      triggerExport(format) {
        if (format === 'csv') {
          this.$emit('usersExportCSV');
        } else if (format === 'xls') {
          this.$emit('usersExportXLS');
        }
      },
    }
  }
</script>

<style scoped type="text/css" lang="scss">
  .dropdown-wrapper {
    position: relative;
  }

  .dropdown-menu {
    padding: 0;
    right: 0;

    .dropdown-item {
      padding: 0;
      display: flex;
      margin-top: 4px;
    }

    button {
      flex: 1;
      border: 0;
      padding: 8px 0;
      line-height: 1.4;
      cursor: pointer;
      &:hover {
        background: #cccccc;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/users/UsersExportButton.vue